import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { UserService } from 'src/app/services/userService/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.less']
})
export class RegisterComponent {
  registerGroup: FormGroup;
  mailGroup: FormGroup;
  countDown = 100;
  countDownTime;
  countInterval;
  hide = true;
  constructor(private formBuilder: FormBuilder, private subscriberService: SubscriberService, private userService: UserService) {
    const reqex = ".{6,}";

    // Register
    this.registerGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}$')]],
      password: ['', [Validators.required, Validators.pattern(reqex)]],
      coupon: [''],
      privacy: [false, Validators.requiredTrue],
      next: ['', Validators.required]
    });

    // Register PIN
    this.mailGroup = this.formBuilder.group({
      pin: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      next: ['', Validators.required]
    });
  }

  // Register New User
  register(stepper) {
    this.subscriberService.register({
      email: this.registerGroup.controls.email.value,
      password: this.registerGroup.controls.password.value,
      coupon: this.registerGroup.controls.coupon.value,
      language: this.userService.getLanguageService().getLanguage()
    }).then((resp: any) => {
      this.registerGroup.controls.next.setValue(true);
      stepper.next();
      this.onRegister();
    });
  }

  // Validates Register PIN
  validatePin(stepper) {
    this.subscriberService.validateRegisterPin({
      email: this.registerGroup.controls.email.value,
      password: this.registerGroup.controls.password.value,
      pin: this.mailGroup.controls.pin.value
    }).then((resp: any) => {
      this.mailGroup.controls.next.setValue(true);

      // Get User Info and move to next step
      this.userService.getUserInfo().then((resp: any) => {
        this.userService.getToken().then(token => {
          this.userService.checkStatus(resp);
          this.userService.getLoggedInStatus.next(true);
          stepper.next();
        });
      })
    });

  }

  // It handling PIN expiration UI timers
  onRegister() {
    const timeOut = this.userService.getServerConfigs().registerPinTimeout || 5; // value in minutes
    let now = timeOut * 60000; //timeOut minutes into mileseconds
    const duration = timeOut * 60000; //timeOut minutes into mileseconds
    let time = timeOut * 60, tmp = time; // Label Timer

    clearInterval(this.countInterval);
    this.countInterval = setInterval(() => {
      now = now - 1000;
      this.countDown = (now / duration) * 100;

      // Count Down Timer Label
      let c = tmp--;
      let m = (c / 60) >> 0;
      let s = (c - m * 60) + '';
      this.countDownTime = m + ':' + (s.length > 1 ? '' : '0') + s;
      tmp != 0 || (tmp = time);

      if (this.countDown <= 0) {
        clearInterval(this.countInterval);
      }
    }, 1000);
  }
}